import configData from "../config.json";
import React from "react";
import { setUserSession } from "../components/Session";
import SlideButton from 'react-slide-button';
import biglogo from "../assets/biglogo.png";

import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
const SignIn = () => {
    let u = localStorage.getItem("WBU");
    let p = localStorage.getItem("WBP");
    if (u === undefined) u = "";
    if (p === undefined) p = "";
    const [username, setUsername] = React.useState(u);
    const [password, setPassword] = React.useState(p);
    const [fail, setFail] = React.useState(false);
    const [reset, setReset] = React.useState(0);

    React.useEffect(() => {
        if (u !== "" && p !== "") submitted();
    }, []);

    const submitted = async (e) => {
        try {
            var url = `${configData.SERVER_URL}apiV7/Auth`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                mode: "cors",
                body: JSON.stringify({
                    username,
                    password,
                }),
            });

            if (response.ok) {
                setFail(false)
                const data = await response.json();
                setUserSession(data);
                if (data.autologin) {
                    localStorage.setItem("WBU", username);
                    localStorage.setItem("WBP", password);
                } else {
                    localStorage.setItem("WBU", "");
                    localStorage.setItem("WBP", "");
                }
                window.location.href = data.initialPage;
            } else {
                setFail(true)
                localStorage.setItem("WBU", "");
                localStorage.setItem("WBP", "");
                setReset(counter => counter + 1)
                console.error("Login failed");
            }
        } catch (error) {
            setReset(counter => counter + 1)
            console.error("Login error:", error);
        }
    };

    const setUser = (e) => {
        setUsername(e.target.value);
    }

    const setPass = (e) => {
        setPassword(e.target.value);
    }

    return (

        <div>
            <div >
                <div className="form-container sign-in-container" style={{ background: "#021417" }} >
                    <form>
                        <img src={biglogo} alt="EZYweigh" style={{ maxHeight: "380px" }} />
                        <h1 style={{ color: "white" }}>Sign in</h1>
                        <input
                            required
                            type="text"
                            placeholder="User Name"
                            name="username"
                            value={username}
                            onChange={setUser}
                            style={{ margin: "3px 0px" }}
                        />
                        <input
                            required
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            onChange={setPass}
                            style={{ margin: "3px 0px 10px" }}
                        />
                        {fail && <h6 style={{ color: "red" }}>Invalid User Name or Password</h6>}
                        <div style={{ background: "white" }}>
                        <SlideButton className="slide-submit"
                            mainText="Slide to Enter"
                            overlayText="Submitted"
                            caretClassList="my-caret-class"
                            overlayClassList="my-overlay-class"
                            onSlideDone={function () {
                                submitted();
                            }}
                            reset={reset}
                            />
                        </div>
                    </form>
                </div>
                <footer>
                    <p>
                        <a href="/resetpassword">
                            <b>Reset Password</b>
                        </a>
                        &nbsp; &nbsp; &nbsp;
                        <a href="https://wms.screenconnect.com" target="_blank">
                            <b>Remote Support</b>
                        </a>
                        &nbsp; &nbsp; &nbsp;
                        <a href="https://weigh-more.com.au/contact/" target="_blank">
                            <b>Contact Us</b>
                        </a>
                        &nbsp; &nbsp; &nbsp;
                        <a href="https://weigh-more.com.au/about-us/" target="_blank">
                            <b>About</b>
                        </a>
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default SignIn;
